import { motion } from "framer-motion";
import { useContext } from "react";
import { EaseContext, WidthContext } from "../App";
import { State } from "./KlimaContent";

interface Props {
  setCurrentState: (state: State) => void;
}

export const WelcomeContentExit: React.FC<Props> = ({ setCurrentState }) => {
  const handleClick = () => {
    setCurrentState("question");
  };

  const width = useContext(WidthContext);
  const ease = useContext(EaseContext);

  return (
    <motion.div
      initial={{ opacity: 1, x: 0 }} // 初期状態
      animate={{ opacity: 0, x: -width }} // マウント時
      exit={{ x: 20 }} // アンマウント時
      transition={{
        duration: 0.5,
        ease: ease,
      }}
      className="w-full rounded-xl shadow-xl my-8 md:px-6 py-10 bg-slate-50 px-2 absolute top-0 -z-10"
    >
      <h1 className="text-center text-2xl md:text-3xl mb-2 font-semibold text-gray-10 leading-8">
        カーボンフットプリント<br />ばりぐっどくん
      </h1>
      <div className="flex justify-center">
        <img src="/images/welcome.png" alt="welcome" className="h-64" />
      </div>
      <p className="px-2 md:px-6 py-3 text-sm leading-[1.6] text-gray-10">
        <span className="block md:inline text-center">
          簡単なアンケートに答えるだけで、
        </span>
        <span className="block md:inline text-center">
          あなたの年間CO2排出量を計算できるよ！
        </span>
      </p>
      <div className="flex justify-center mt-5 mb-3 px-4">
        <button className="btn w-full text-slate-50" onClick={handleClick}>
          はじめる
        </button>
      </div>
    </motion.div>
  );
};
